import "react-phone-number-input/style.css";
import RCPhoneInput, {
  DefaultInputComponentProps,
  Props,
} from "react-phone-number-input";
import { cn } from "../../styles/utils";
import { commonStyles, variantStyles } from "./TextField";

type InputProps = Readonly<Props<DefaultInputComponentProps>> & {
  variant?: keyof typeof variantStyles;
  error?: string;
};

export default function PhoneInput({
  variant = "light",
  className,
  error,
  ...props
}: InputProps) {
  return (
    <div className="w-full">
      <RCPhoneInput
        {...props}
        className={cn(
          commonStyles,
          variantStyles[variant].enabled,
          className,
          error && "border-red",
        )}
      />
      {error && <p className="text-red text-xs mt-1 px-3">{error}</p>}
    </div>
  );
}
